import React, { useState, useEffect } from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import Sortable from "./Sortable";
import arrayMove from "array-move";
import { ReactComponent as Check } from "../assets/svg/check.svg";
import { ReactComponent as Wrong } from "../assets/svg/wrong.svg";

const LessonDataListOrder = ({ seed, freeze = false, onChange = () => {} }) => {
  const [state, setState] = useState([]);

  useEffect(() => {
    setState(initState(seed));
  }, [seed]);

  useEffect(() => {
    onChange({
      ready: true,
      data: state,
    });
  }, [state, onChange]);

  const onSortEnd = ({ oldIndex, newIndex }) =>
    setState((state) => arrayMove(state, oldIndex, newIndex));

  return (
    <>
      <GlobalStyles />
      <Container freeze={freeze}>
        <Sortable
          pressDelay={document.documentElement.clientWidth > 600 ? 0 : 100}
          items={state}
          render={(item, index) => (
            <Text key={index} state={item.state}>
              {item.text}
              {item.state && <StateIcon as={stateIcon[item.state]} />}
            </Text>
          )}
          onSortEnd={onSortEnd}
          helperClass="helperItem"
        />
      </Container>
    </>
  );
};

const stateIcon = {
  SUCCESS: Check,
  FAILURE: Wrong,
};

const initState = (seed) => {
  let state = seed;
  return state;
};

const GlobalStyles = createGlobalStyle`

  .helperItem {
    box-shadow: 0 0 7px 5px rgba(0,0,0,0.1);
    border: 2px dashed green;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    z-index: 200;
  }

`;

const Text = styled.div`
  position: relative;
  user-select: none;
  font-size: 0.9em;
  background-color: #caedff;
  padding: 20px 25px;
  border-radius: 15px;

  overflow: hidden;
  box-sizing: border-box;
  cursor: grab;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
  ${(props) =>
    props.state &&
    css`
      padding-bottom: 60px;
    `}
`;

const StateIcon = styled.div`
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  position: absolute;
  bottom: 18px;
  left: 0px;
  right: 0px;
  margin: 0 auto;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 20px;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;

  ${(props) =>
    props.freeze &&
    css`
      pointer-events: none;
    `}
`;

export default LessonDataListOrder;
